
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pmm",
      function () {
        return require("private-next-pages/pmm.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pmm"])
      });
    }
  